import { useMutation } from "@tanstack/react-query";

const getProductList = async () => {
    // const response = await AxiosConfig.post("/api/login", JSON.stringify(credentials), {
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // });
    const response = await fetch("/api/items", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    // if (!response.ok) {
    //     const errorData = await response.json();
    //     throw new Error(errorData.message || "로그인에 실패했습니다.");
    // }

    const data = await response.json();
    if (response.ok) {
        console.log("상품데이터 불러오기 성공 : ", data);
        const itemList = data;
        console.log('아이템리스트 : ', itemList);
        return data;
    } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "상품 데이터 불러오기에 실패했습니다.");
    }

};

export const useGetProductMutation = () => {
    return useMutation({
        mutationFn: getProductList,
        onSuccess: (data) => {
            // console.log("상품 데이터 불러오기 성공 : ", data);
            return data;
        },
        onerror: (error) => {
            console.error("상품 데이터 불러오기 실패 : ", error);
            return error;
        },
    });
};